// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AdditionalServices_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/additional_services/salvar
 *
 * Creates or updates an additional service. When so_additional_service_id is provided,
 * updates existing; otherwise creates new. Price is stored in cents (multiply by 100).
 */
import { registerContract } from './validate'

export interface AdditionalServices_SalvarInput {
so_additional_service_category_id: number
so_additional_service_default_price: number
so_additional_service_id?: number
so_additional_service_name?: string
so_additional_service_description?: string
so_additional_service_additional_deadline_days?: number
}

registerContract('AdditionalServices_SalvarInput', {
  so_additional_service_category_id:              { type: 'number',  required: true },
  so_additional_service_default_price:            { type: 'number',  required: true },
  so_additional_service_id:                       { type: 'number',  required: false },
  so_additional_service_name:                     { type: 'string',  required: false },
  so_additional_service_description:              { type: 'string',  required: false },
  so_additional_service_additional_deadline_days: { type: 'number',  required: false },
})
